{
  "review_contacts_table": {
    "clear_selection": "Clear selection",
    "alert_message": "Review and manage your incoming contacts here. By selecting the checkbox next to a contact, you can choose to release them to the CRM, set them as private, or archive their details.",
    "contacts_selected": "{{count}} contacts selected",
    "contact_column": "Contact",
    "company_column": "Company",
    "location_column": "Location",
    "tags_column": "Tags",
    "last_interaction_column": "Last Interaction"
  },
  "allow_marketing": {
    "success_description": "These contacts now allowed for marketing!"
  },
  "set_as_private": {
    "confirm_title": "Set Contacts as Private",
    "confirm_content": "Any future interactions (e.g. activity feed, who knows) that include you and these contacts will not be tracked.",
    "delete_past_interactions": "Delete past interactions between you and this contact. This action cannot be undone.",
    "remove_from_my_contacts": "Remove from My Contacts",
    "button": "Set As Private",
    "success_description": "These contacts have been set to private."
  },
  "merge_contacts": {
    "select_instruction": "Select contacts which you want to merge",
    "set_primary_instruction": "Set one of these Contacts as Primary",
    "primary_label": "Primary",
    "set_as_primary": "Set as Primary",
    "continue": "Continue",
    "merge_data_title": "Following data will be merged and added under Primary Contact",
    "replace_data_title": "Following data will be replaced with Primary Contact's data:",
    "merge_items": {
      "activity_feed": "Activity Feed",
      "who_knows": "Who knows",
      "notes": "Notes",
      "tasks": "Tasks",
      "phone_numbers": "Phone numbers",
      "emails": "Emails"
    },
    "replace_items": {
      "marketing_settings": "Marketing setting",
      "list_membership": "List membership",
      "company": "Company",
      "location": "Location",
      "job_title": "Job title"
    },
    "confirmation_text": "I understand that merging these contacts will combine their data under a single profile. This action cannot be undone.",
    "merge_button": "Merge contacts"
  },
  "actions": {
    "archive_contact": "Archive Contact"
  }
}
